<template>
    <div>
        <template v-if="applicationInitialized">
            <router-view/>
        </template>
        <b-loading v-model="isGlobalLoaderActive" :is-full-page="true"></b-loading>
    </div>
</template>


<script>
import { mapActions, mapGetters } from 'vuex'
import GlobalLoaderMixin from '@/mixins/GlobalLoaderMixin'
import InitializeMixin from '@/mixins/InitializeMixin'

import IdleMixin from '@/mixins/IdleMixin'
import { restoreCache } from '@/store/cache'
import { config, fetchEnv } from './env'
import api from './helpers/api'

export default {
    mixins: [
        GlobalLoaderMixin,
        IdleMixin,
        InitializeMixin,
    ],
    data () {
        return {

        }
    },
    created () {
        this.addGlobalLoader()

        fetchEnv().then(()=>{
            api.updateBaseUrl(config('API_ENDPOINT'))
            //this.fetchCurrent()
            this.restoreToken().then(()=>{
                this.fetchCurrent().then(()=>{}).catch((e)=>{})
            }).catch((e)=>{})

            this.setApplicationInitialized()
        }).finally(()=>{
            this.removeGlobalLoader()
        })

        restoreCache()
    },
    computed: {
        ...mapGetters({}),
    },
    methods: {
        ...mapActions({
            restoreToken: 'e/users/restoreToken',
            fetchCurrent: 'e/users/fetchCurrent',
        }),
    },
}
</script>
